import React from 'react';
import { IonIcon } from '@ionic/react';
import { warning } from 'ionicons/icons';
import { useNetworkQuality } from '../hooks/useNetworkQuality';

export const SlowConnectionBanner: React.FC = () => {
  const { isSlowConnection, isOffline } = useNetworkQuality();

  if (!isSlowConnection || isOffline) return null;

  return (
    <div
      style={{
        padding: '8px 12px',
        backgroundColor: '#fef3c7',
        borderLeft: '4px solid #f59e0b',
        margin: '0 12px 12px',
        borderRadius: '4px',
        fontSize: '13px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
      }}
      role="alert"
    >
      <IonIcon icon={warning} style={{ color: '#f59e0b' }} />
      Connessione lenta rilevata. Alcuni dati potrebbero provenire dalla cache.
    </div>
  );
};
